import Vue from 'vue';
import { assign } from 'lodash';
import * as api from 'api/api-stuff-to-eat';
import * as types from '../mutation-types';

const initState = {
  fetching: false,
  fetched: false,
  search: false,
  error: null,
  saving: false,
  saveError: false,
  meta: {},
  data: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  empty: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = {};

const getters = {
  StuffToEatInstruction: state => entityInstructionID => state[entityInstructionID],
};

const actions = {
  InitStuffToEatInstruction({ commit }, params) {
    const entityInstructionID = params.entityInstructionID;
    commit(types.CLEAR_STUFF_TO_EAT_INSTRUCTION, { entityInstructionID });
  },
  GetStuffToEatInstruction({ commit }, params) {
    const type = params.type;
    const id = params.id;
    const entityInstructionID = params.entityInstructionID;
    commit(types.FETCH_STUFF_TO_EAT_INSTRUCTION_START, { entityInstructionID });
    api.getInstruction(
      type,
      id,
      entityInstructionID,
      (response) => {
        commit(types.RECEIVE_STUFF_TO_EAT_INSTRUCTION, { entityInstructionID, response });
      },
      (description, status, error) => {
        commit(types.FETCH_STUFF_TO_EAT_INSTRUCTION_ERROR, { entityInstructionID, error });
      },
    );
  },
  AddStuffToEatInstruction({ dispatch, commit }, params) {
    console.log('AddStuffToEatInstruction', params);
    return new Promise((resolve, reject) => {
      const type = params.type;
      const id = params.id;
      const entityInstructionID = params.entityInstructionID;
      const payload = params.payload;
      commit(types.SAVE_STUFF_TO_EAT_INSTRUCTION_START, { entityInstructionID });
      api.addInstruction(
        type,
        id,
        payload,
        (response) => {
          commit(types.SAVE_STUFF_TO_EAT_INSTRUCTION_SUCCESSFUL, { entityInstructionID, response });
          dispatch('AddStuffToEatInstructionToInstructionList', { id, response });
          // dispatch('AddInstructionToStuffToEatDetails', { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.SAVE_STUFF_TO_EAT_INSTRUCTION_ERROR, { entityInstructionID, saveError });
          reject(saveError);
        },
      );
    });
  },
  EditStuffToEatInstruction({ dispatch, commit }, params) {
    console.log('EditStuffToEatInstruction', params);
    return new Promise((resolve, reject) => {
      const type = params.type;
      const id = params.id;
      const payload = params.payload;
      // TODO: changed data to payload in params
      const entityInstructionID = params.entityInstructionID;
      commit(types.UPDATE_STUFF_TO_EAT_INSTRUCTION_START, { entityInstructionID });
      api.editInstruction(
        type,
        id,
        entityInstructionID,
        payload,
        (response) => {
          commit(types.UPDATE_STUFF_TO_EAT_INSTRUCTION_SUCCESSFUL, { entityInstructionID, response });
          dispatch('EditStuffToEatInstructionInInstructionList', { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.UPDATE_STUFF_TO_EAT_INSTRUCTION_ERROR, { entityInstructionID, saveError });
          reject(saveError);
        },
      );
    });
  },
  DeleteStuffToEatInstruction({ dispatch, commit }, params) {
    console.log('DeleteStuffToEatInstruction', params);
    return new Promise((resolve, reject) => {
      const type = params.type;
      const id = params.id;
      const entityInstructionID = params.entityInstructionID;
      commit(types.DELETE_STUFF_TO_EAT_INSTRUCTION_START, { entityInstructionID });
      api.removeInstruction(
        type,
        id,
        entityInstructionID,
        (response) => {
          commit(types.DELETE_STUFF_TO_EAT_INSTRUCTION_SUCCESSFUL, { entityInstructionID, response });
          dispatch('RemoveStuffToEatInstructionFromInstructionList', { id, entityInstructionID });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.DELETE_STUFF_TO_EAT_INSTRUCTION_ERROR, { entityInstructionID, saveError });
          reject(saveError);
        },
      );
    });
  },
  ClearStuffToEatInstruction({ commit }, { entityInstructionID }) {
    commit(types.CLEAR_STUFF_TO_EAT_INSTRUCTION, { entityInstructionID });
  },
};

const mutations = {
  [types.FETCH_STUFF_TO_EAT_INSTRUCTION_START](state, { entityInstructionID }) {
    console.log('FETCH_STUFF_TO_EAT_INSTRUCTION_START');
    if (state[entityInstructionID]) Vue.set(state, entityInstructionID, assign(state[entityInstructionID], neutralState, { fetching: true }));
    else Vue.set(state, entityInstructionID, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_STUFF_TO_EAT_INSTRUCTION_ERROR](state, { entityInstructionID, error }) {
    console.log('FETCH_STUFF_TO_EAT_INSTRUCTION_ERROR');
    Vue.set(state, entityInstructionID, assign(state[entityInstructionID], neutralState, { error }));
  },
  [types.RECEIVE_STUFF_TO_EAT_INSTRUCTION](state, { entityInstructionID, response }) {
    console.log('RECEIVE_STUFF_TO_EAT_INSTRUCTION', response);
    Vue.set(state, entityInstructionID, assign(state[entityInstructionID], neutralState, { ready: true, data: response.data, meta: response.meta }));
  },

  [types.CLEAR_STUFF_TO_EAT_INSTRUCTION](state, { entityInstructionID }) {
    console.log('CLEAR_STUFF_TO_EAT_INSTRUCTION');
    Vue.set(state, entityInstructionID, assign({}, initState));
  },

  [types.SAVE_STUFF_TO_EAT_INSTRUCTION_START](state, { entityInstructionID }) {
    console.log('SAVE_STUFF_TO_EAT_INSTRUCTION_START');
    Vue.set(state, entityInstructionID, assign(state[entityInstructionID], neutralState, { saving: true }));
  },
  [types.SAVE_STUFF_TO_EAT_INSTRUCTION_SUCCESSFUL](state, { entityInstructionID, response }) {
    console.log('SAVE_STUFF_TO_EAT_INSTRUCTION_SUCCESSFUL', response);
    Vue.set(state, entityInstructionID, assign(state[entityInstructionID], neutralState, { data: response.data, meta: response.meta }));
  },
  [types.SAVE_STUFF_TO_EAT_INSTRUCTION_ERROR](state, { entityInstructionID, saveError }) {
    console.log('SAVE_STUFF_TO_EAT_INSTRUCTION_ERROR');
    Vue.set(state, entityInstructionID, assign(state[entityInstructionID], neutralState, { saveError }));
  },

  [types.UPDATE_STUFF_TO_EAT_INSTRUCTION_START](state, { entityInstructionID }) {
    console.log('UPDATE_STUFF_TO_EAT_INSTRUCTION_START');
    Vue.set(state, entityInstructionID, assign(state[entityInstructionID], neutralState, { saving: true }));
  },
  [types.UPDATE_STUFF_TO_EAT_INSTRUCTION_SUCCESSFUL](state, { entityInstructionID, response }) {
    console.log('UPDATE_STUFF_TO_EAT_INSTRUCTION_SUCCESSFUL', response);
    Vue.set(state, entityInstructionID, assign(state[entityInstructionID], neutralState, { data: response.data, meta: response.meta }));
  },
  [types.UPDATE_STUFF_TO_EAT_INSTRUCTION_ERROR](state, { entityInstructionID, saveError }) {
    console.log('SAVE_STUFF_TO_EAT_INSTRUCTION_ERROR');
    Vue.set(state, entityInstructionID, assign(state[entityInstructionID], neutralState, { saveError }));
  },

  [types.DELETE_STUFF_TO_EAT_INSTRUCTION_START](state, { entityInstructionID }) {
    console.log('DELETE_STUFF_TO_EAT_INSTRUCTION_START');
    Vue.set(state, entityInstructionID, assign(state[entityInstructionID], neutralState, { saving: true }));
  },
  [types.DELETE_STUFF_TO_EAT_INSTRUCTION_SUCCESSFUL](state, { entityInstructionID }) {
    console.log('DELETE_STUFF_TO_EAT_INSTRUCTION_SUCCESSFUL', entityInstructionID);
    Vue.set(state, entityInstructionID, assign({}, initState));
  },
  [types.DELETE_STUFF_TO_EAT_INSTRUCTION_ERROR](state, { entityInstructionID, saveError }) {
    console.log('DELETE_STUFF_TO_EAT_INSTRUCTION_ERROR');
    Vue.set(state, entityInstructionID, assign(state[entityInstructionID], neutralState, { saveError }));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/stuff-to-eat/entities/stuff-to-eat-instruction.js